import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_MY',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '78ba9599-b4ab-43bf-8a56-d080f3c7fae9',
  ''
);
